// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uvTy","question":"styles_question__1SApM","description":"styles_description__3M-eC"};